<script lang="ts">
    import {router} from 'tinro';

    import List, {Item, Graphic, Separator, Text, PrimaryText, SecondaryText} from '@smui/list'
    import Textfield from '@smui/textfield'
    import Icon from '@smui/textfield/icon'

    import NamedRightsEditor from './NamedRightsEditor.svelte'

    import type {ReadyList, Named, Rights, NamedRights} from './jmdb'
    import {deep_copy, newId, right_list } from "./jmdb"
    
    export let right_id: string | undefined = undefined

    let newGroupSelected = false
    $: newGroupSelected = (right_id == newId.toString())

    let filterText = ''
    let selectedRights: NamedRights | undefined
    let right_list_sorted: ReadyList<NamedRights>

    right_list.fetch()
    $: right_list_sorted = {ready: $right_list.ready, data: $right_list.data.map(v=>v).sort((a, b) => a.name.localeCompare(b.name))}     


    let emptyRight: NamedRights = {id: newId, name: '', streamers: {}, streamerGroups: {}}
    $: selectedRights = newGroupSelected ? emptyRight : (right_list_sorted.data.find((v) => v.id == Number(right_id)) || undefined)

    
</script>


<div class="row">
    <div class="col-md-3">
        <div style="display: flex; flex-wrap: nowrap;">
            <Textfield withLeadingIcon label="Find" bind:value={filterText} >
                <Icon class="material-icons">search</Icon>
            </Textfield>
        </div>

    </div>
</div>
<div class="row">
    <div class="col-md-3 user-list">
        {#if !right_list_sorted.ready}
            Loading...
        {:else}
            <List singleSelection>
                {#each right_list_sorted.data as actor}
                {#if (!filterText || actor.name.toLowerCase().indexOf(filterText.toLowerCase()) != -1)}
                <Item selected={actor.id == Number(right_id)}>
                    <a class="divLink" href="/mgr/rights/{actor.id}">&nbsp;</a>
                    <Text>{actor.name}</Text>
                </Item>
                <Separator />
                {/if}
                {/each}
            </List>
            <List singleSelection>
                <Item selected={newGroupSelected}>
                    <a class="divLink" href="/mgr/rights/{newId}">&nbsp;</a>
                    <Graphic class="material-icons">add</Graphic>
                    <Text>New rights</Text>
                </Item>
            </List>
        {/if}
    </div>
    <div class="col-md-9">
        {#if !selectedRights }
            Nothing is selected
        {:else}
            {#key selectedRights}
            <NamedRightsEditor namedRights={deep_copy(selectedRights)}/>
            {/key}
        {/if}
    </div>

</div>